import { ColDef } from "ag-grid-community";

export const agGridActionColumnDefaultColumnDef: ColDef = {
  pinned: "right",
  filter: false,
  lockVisible: true,
  sortable: false,
  resizable: false,
  lockPinned: true,
  enableRowGroup: false,
  lockPosition: "right",
  suppressMovable: true,
  suppressAutoSize: true,
  suppressSizeToFit: true,
  suppressColumnsToolPanel: true,
  suppressHeaderContextMenu: true,
  suppressHeaderMenuButton: true,
  suppressHeaderFilterButton: true,
  suppressFloatingFilterButton: true,
  suppressKeyboardEvent: () => true,
};
